class EmitterMessages {
  event: Event

  dispatch = (name: string, detail: object) => {
    this.event = new CustomEvent(name, detail)
    dispatchEvent(this.event)
  }

  subscribe = (name: string, listenerCallback: (e) => void) => {
    addEventListener(name, listenerCallback, false)
  }

  unsubscribe = (name: string, removeCallback?: (e) => void) => {
    removeEventListener(name, removeCallback)
  }
}

export const emmiter = new EmitterMessages()
